import React, {Component} from "react";
import Themes from "../../Common/Themes/Themes";
import ChangePassword from "./ChangePassword/ChangePassword";
interface Props {
  pageStatus: string;
}

const Setting: React.FC<Props> = ({pageStatus}) => {
  return (
    <div>
      {pageStatus == "password_change" ? <ChangePassword /> : null}
      {pageStatus == "themes" ? <Themes /> : null}
      {pageStatus == "family" ? null : null}
      {pageStatus == "vehicles" ? null : null}
      {pageStatus == "house" ? null : null}
    </div>
  );
};

export default Setting;
